<template>
    <div>
        <textarea
            :name="name"
            :id="generatedId"
            ref="editor"
            v-model="currentValue"
        >
        </textarea>
    </div>
</template>

<script>
    // function EditCKE(editor) {
    //     this.editor = editor;
    // }
    //
    // EditCKE.prototype.init = function() {
    //     const editor = this.editor;
    //     let minHeight = editor.config.get('minHeight');
    //
    //     editor.ui.view.editable.extendTemplate({
    //         attributes: {
    //             style: {
    //                 minHeight
    //             }
    //         }
    //     });
    // };
    //
    // ClassicEditor.builtinPlugins.push(EditCKE);

    export default {
        name: "CKEditor",
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: String,
                default: ''
            },
            minHeight: {
                type: String,
                default: '350px'
            }
        },
        data: () => ({
            currentValue: '',
            getId: null,
            instance: null,
        }),
        methods: {},
        computed: {
            generatedId() {
                this.getId = this.name + Math.random().toString(36).substr(2, 9);
                return this.getId;
            }
        },
        mounted: function () {
            this.currentValue = this.value;

            CKEDITOR.replace(this.$refs.editor);

            this.instance = CKEDITOR.instances[this.getId];

            this.instance.on('change', () => {
                this.$emit('input', this.instance.getData());
            })
        }
    }
</script>
